import { composeClassNames } from "@faedev/editor-utils";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { CSSProperties } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import Paragraph from "src/components/Paragraph";
import Translate from "src/components/Translate";
import constants from "src/constants";
import getLink from "src/functions/getLink";
import profileNameText from "src/functions/profileNameText";
import translate from "src/functions/translate";
import Small_chevron_right from "src/icons/Small-chevron-right";
import { sButton } from "src/styles/sButton.module.scss";
import { sInstructorHighlight } from "src/styles/sInstructorHighlight.module.scss";
import { sInstructorImg } from "src/styles/sInstructorImg.module.scss";
import { ApiProfileNested } from "src/types/ApiProfileNested";
import ExperienceLevelBadge from "./ExperienceLevelBadge";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: ApiProfileNested;
  curator?: boolean;
};

function InstructorHighlight({ style, className, data, curator }: Props) {
  const { locale: lang } = useRouter();
  return data ? (
    <div
      className={composeClassNames([
        sInstructorHighlight,
        className,
        "instructor-highlight",
      ])}
      style={style}
    >
      <Row>
        <Col sm={3} xs={12}>
          {data.thumbnail && (
            <Image
              src={constants.Paths.imagesUrl + data?.thumbnail?.url}
              className={composeClassNames([sInstructorImg, `sm`])}
              alt={translate("Profile photo", lang) + ` ${data.nickname}`}
              width={constants.Images.profilePhotoPhone}
              height={constants.Images.profilePhotoPhone}
              layout="fixed"
            />
          )}
          <ExperienceLevelBadge
            level={data.experience?.level}
            instructorHightlight={true}
          />
        </Col>
        <Col sm={9} xs={12}>
          {curator && (
            <Heading
              type="h6"
              title={<Translate tKey={`Playlist Curator`} />}
              uppercase
              variant="primary"
            />
          )}
          <Heading
            type="h3"
            title={profileNameText(
              data.client?.name,
              data.client?.surname,
              data.nickname,
              data.type
            )}
          />
          <Paragraph size="xn">{data.label}</Paragraph>
          <Link
            href={getLink(lang, `profile`, data.slug, null)}
            passHref
            locale={false}
          >
            <Button
              variant={`outline-dark`}
              as="a"
              className={composeClassNames([sButton, "btn-icon-after"])}
            >
              <Translate tKey={`Show profile`} />
              <Small_chevron_right />
            </Button>
          </Link>
        </Col>
      </Row>
    </div>
  ) : null;
}

export default InstructorHighlight;
